import graphql__297beff5121d7e1f29f6 from "./__generated__/ComplexMenuMobileMainNavigation_navigationItems.graphql.js";
import graphql__7dd874c2afc913b47a95 from "./__generated__/ComplexMenuMobileMainNavigation_platform.graphql.js";import { graphql, useFragment } from "react-relay";

import ComplexMenuMobileNavigationItem from "./ComplexMenuMobileNavigationItem";
import LocaleSwitch from "../../../LocaleSwitch";

const ComplexMenuMobileMainNavigation = props => {
  const platform = useFragment(ComplexMenuMobileMainNavigation_platform, props.platform);
  const navigationItems = useFragment(
    ComplexMenuMobileMainNavigation_navigationItems,
    props.navigationItems
  );
  const { primaryColor, publishedLocales } = platform;

  return (
    <ul className="complex-menu-mobile-navigation list-unstyled padding-none">
      {navigationItems.map(navigationItem => {
        const childItems = navigationItem.children;

        return (
          <ComplexMenuMobileNavigationItem
            key={navigationItem.id}
            navigationItem={navigationItem}
            childItems={childItems}
            isTopLevel
            primaryColor={primaryColor}
          />
        );
      })}

      {publishedLocales.length > 1 && <LocaleSwitch platform={platform} />}
    </ul>
  );
};

const ComplexMenuMobileMainNavigation_navigationItems = graphql__297beff5121d7e1f29f6;

const ComplexMenuMobileMainNavigation_platform = graphql__7dd874c2afc913b47a95;

export default ComplexMenuMobileMainNavigation;
